export default __webpack_public_path__ + "static/media/shopping-cart-10903.f75efce8.svg";